<template>
    <div class="container-fluid w-100" style="overflow: hidden; background: transparent">
        <navbar :title="$t('menu.mvr_inspections')"/>
        <div class="col-sm-12 transparent-bg mt-2" style="overflow: hidden">
            <Transition name="fade">
                <div v-show="!showInspectionWizard" class="col-12 nopads">
                    <!-- Tabs -->
                    <ul class="nav nav-tabs routa-tabs">
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 0 }" @click="tabIndex = 0">
                               {{ $t('mvr_inspection.inspection_report_details.title') }}
                            </button>
                                     </li>
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 1 }" @click="tabIndex = 1">
                                {{ $t('mvr_inspection.template.inspection_templates_title') }}
                            </button>
                                     </li>
                        <li class="nav-item">
                            <button class="routa-tab" :class="{ active: tabIndex === 2 }" @click="tabIndex = 2">
                                {{ $t('mvr_inspection.inspectable_editor.inspectable') }}
                            </button>
                                     </li>
                    </ul>
                    <!-- Content -->
                    <div class="tab-content routa-tab-content">
                        <div class="tab-pane fade" :class="{ show: tabIndex === 0, active: tabIndex === 0 }" style="min-height: 80vh">
                            <mvr-inspection-reports ref="reports" @add="showInspectionWizard = true" @onReport="handleSelectedReport" />
                        </div>
                        <div class="tab-pane fade" :class="{ show: tabIndex === 1, active: tabIndex === 1 }" style="min-height: 80vh">
                            <mvr-inspection-templates-view />
                        </div>
                        <div class="tab-pane fade" :class="{ show: tabIndex === 2, active: tabIndex === 2 }" style="min-height: 80vh">
                            <mvr-inspectables-view />
                        </div>
                    </div>
                </div>
            </Transition>
        </div>
        <base-modal v-if="showInspectionWizard" size="xl" hide-footer hide-header>
            <mvr-inspection-wizard @close="showInspectionWizard = false" @closeAndUpdate="updateResults" />
        </base-modal>
        <base-modal v-if="showReportDetails" size="xl" :hide-header="true" :hide-footer="true" @close="clearReportDetails">
            <mvr-inspection-report-details :reportDetails="reportDetails" :user="user" @close="clearReportDetails" />
        </base-modal>
        <div v-if="loading" id="loader" class="spinner" />
    </div>
</template>

<script>
import MvrInspectionReports from '@/components/inspections/mvrInspections/MvrInspectionReports'
import MvrInspectablesView from '@/components/inspections/mvrInspections/MvrInspectablesView'
import MvrInspectionTemplatesView from '@/components/inspections/mvrInspections/MvrInspectionTemplatesView'
import MvrInspectionWizard from '@/components/inspections/mvrInspections/MvrInspectionWizard'
import MvrInspectionReportDetails from '@/components/inspections/mvrInspections/MvrInspectionReportDetails'
import BaseModal from "@/components/BaseModal";
import Navbar from "@/components/utils/Navbar";

export default {
    name: 'MvrInspectionsView',
    components: {
        Navbar,
        BaseModal,
        MvrInspectionReports,
        MvrInspectionTemplatesView,
        MvrInspectablesView,
        MvrInspectionWizard,
        MvrInspectionReportDetails
    },
    mixins: [],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            showReportDetails: false,
            showInspectionWizard: false,
            reportDetails: null,
            tabIndex: 0
        }
    },
    methods: {
        linkTabClass(index) {
            if (this.tabIndex === index) {
                return ['tab-title', 'tab-title-active']
            } else {
                return ['tab-title']
            }
        },
        handleSelectedReport(report) {
            this.reportDetails = report
            this.showReportDetails = true
        },
        clearReportDetails() {
            this.reportDetails = null
            this.showReportDetails = false
        },
        updateResults() {
            this.showInspectionWizard = false
            this.$refs.reports.updateReports()
        }
    }
}
</script>

<style>
.tab-title {
    font-size: .9em;
    border: none !important;
    margin-right: .5em;
    margin-left: .5em;
    color: #949494 !important;
    font-weight: bold;
}

.tab-title:hover {
    color: #007BFF;
}

.tab-title-active {
    border-bottom: 2px solid #7FC000 !important;
}

.tab-title-text {
    color: #949494 !important;
    font-weight: bold;
}


.tab-title-text-active {
    color: #000000 !important;
    font-weight: bold;
}


.tab-title-cont {
    height: 2.5em !important;
    padding-top: 1em;
    padding-bottom: 1em;
}

.contract-tabs .nav-link {
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.contract-tabs .nav-tabs {
    height: 3em;
    padding-top: .55em;
}
</style>
